import { connect } from 'react-redux'
import { Button, Layout } from 'antd'
import { useEffect, useState, useRef } from 'react'
import { withRouter } from 'react-router'
import imgSrc from 'Images/gijstron.jpg'
import WeaverService from 'Services/WeaverService'

GijsplorerLanding = ({ currentProject, history }) ->

  useEffect(->
    (->
      await WeaverService.init()
      await Weaver.getInstance().useProject(currentProject)
    )()
    undefined
  , [])

  <Layout style={{ background: '#000000', padding: '12% 33%', color: 'white', textAlign: 'center', }}>
    <h1 style={{ fontWeight: 700, fontSize: '3rem', color: 'inherit' }}>
      GIJSPLORER
    </h1>
    <img src={imgSrc} style={{ height: 250, objectFit: 'contain' }} />
    <p style={{ margin: '2rem 0' }}>Collect all the Vandernuts before Lord Gijstron gets you.</p>
    <Button
      type="primary"
      onClick={->
        history.push('gijsplore/play')
      }
    >Start game</Button>
  </Layout>

mapStateToProps = ({
  projects: { currentProject }
}) ->
  {
    currentProject
  }

export default connect(mapStateToProps)(
  withRouter(GijsplorerLanding)
)
